<template>
  <div class="ov-page">
    <div class="ov-card">
      <div class="ov-card__head">
        <div class="ov-card__title">
          Comptes
          <span class="ov-count">{{ usersList.length }}</span>
        </div>

        <div class="ov-filters">
          <select
            v-if="isAdminSocieteMere"
            v-model="compagnieTransportRaisonSociale"
            class="ov-select"
            @change="getAllAccountByCompagnie(compagnieTransportRaisonSociale)"
          >
            <option :value="null" disabled>Sélectionner une compagnie</option>
            <option v-for="c in compagnieTransportList" :key="c.raisonSociale" :value="c.raisonSociale">
              {{ c.raisonSociale }}
            </option>
          </select>

          <div class="ov-search">
            <v-icon small>mdi-magnify</v-icon>
            <input v-model="search" type="text" class="ov-input" :placeholder="$t('manageUsers.searchPlaceholder')" />
          </div>

          <button type="button" class="ov-btn ov-btn--primary ov-btn--sm" @click="$router.push('/create_user')">
            <v-icon small>mdi-plus</v-icon>
            Nouveau compte
          </button>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="usersList"
        :loading="loading"
        :search="search"
        loader-height="2"
        :no-data-text="isAdminSocieteMere && !compagnieTransportRaisonSociale ? 'Sélectionnez une compagnie pour afficher ses comptes' : 'Aucun compte utilisateur'"
        class="ov-table"
      >
        <template v-slot:[`item.nom`]="{ item }">
          <div class="su-user">
            <div class="su-user__name">{{ item.nom }} {{ item.prenoms }}</div>
            <div class="su-user__email">{{ item.email }}</div>
          </div>
        </template>

        <template v-slot:[`item.roleCode`]="{ item }">
          <span class="ov-badge ov-badge--navy ov-badge--plain">{{ getRoleLabel(item.roleCode) }}</span>
        </template>

        <template v-slot:[`item.isActif`]="{ item }">
          <span v-if="item.isActif" class="ov-badge ov-badge--success">Actif</span>
          <span v-else class="ov-badge ov-badge--neutral">Inactif</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="ov-row-actions su-actions">
            <button type="button" class="ov-icon-btn" title="Voir le détail" @click="navigateToUserInfo(item)">
              <v-icon small>mdi-eye-outline</v-icon>
            </button>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import axios from "axios";
import {
  API_ACTIVATE_USER,
  HEADERS,
  API_GET_USERS_BY_COMPAGNIE_TRANSPORT,
  API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES,
} from "@/components/globalConfig/globalConstConfig";
import { showErrorMessage } from "@/modules/messages/messageProcess";
export default {
  name: "SelectionnerUtilisateur",
  data() {
    return {
      errorMsg: null,
      cardForAccountShowed: false,

      search: "",

      compagnieTransportList: [],
      compagnieTransportRaisonSociale: null,
      options: {
        index: 0,
        size: 8,
      },

      loading: false,

      simpleObjectToSend: {
        data: {
          compagnieTransportRaisonSociale: null,
        },
      },

      toActive: {
        data: {
          login: null,
        },
      },

      usersList: [],
    };
  },

  methods: {
    getRoleLabel(roleCode) {
      return this.roleLabels[roleCode] || roleCode || '—';
    },

    navigateToUserInfo(user) {
      this.$router.push({ name: "userInfo", params: { nom: user.nom } });
    },

    // ACTIVER UN UTILISATEUR
    async toActivedUser(userItem) {
      this.toActive.data.login = userItem.login;
      await axios
        .post(API_ACTIVATE_USER, this.toActive, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.$swal.fire(
                "Activation",
                response.data.status.message,
                "error"
              );
              this.toActive.data.login = null;
            } else {
              this.$swal.fire(
                "Activation",
                response.data.status.message,
                "success"
              );
              this.toActive.data.login = null;
            }
          } else {
            this.$swal.fire(
              "Activation",
              "Error lors de la validation",
              "error"
            );
            this.toActive.data.login = null;
          }
        })
        .catch((e) => {
          this.$swal.fire("Activation refusée", e, "error");
          this.toActive.data.login = null;
        });
    },

    // Récuperer les bus disponibles par compagnie de transport
    async getAllAccountByCompagnie(compagnieTransport) {
      this.loading = true;
      this.simpleObjectToSend.data.compagnieTransportRaisonSociale =
        compagnieTransport;
      await axios
        .post(API_GET_USERS_BY_COMPAGNIE_TRANSPORT, this.simpleObjectToSend, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code != 800) {
              this.errorMsg = response.data.status.message;
              showErrorMessage();
            } else {
              this.usersList = response.data.items;
            }
          } else {
            this.errorMsg = "Erreur";
            showErrorMessage();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
        })
        .finally(() => {
          this.loading = false;
          this.cardForAccountShowed = true;
        });
    },

    // OBTENIR LA LISTE DES DEMANDES D'ADHESIONS VALIDÉES
    async getCompagnieTransportList() {
      if (
        this.$store.state.userAuthentified.roleCode == "RoleAdminSocieteMere"
      ) {
        await axios
          .post(
            API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES,
            this.options,
            {
              headers: HEADERS(this.$store.state.userAuthentified.token),
            }
          )
          .then((response) => {
            if (response.status == 200) {
              if (response.data.status.code != 800) {
                this.errorMsg = response.data.status.message;
                showErrorMessage();
              } else {
                this.compagnieTransportList = response.data.items;
              }
            } else {
              this.errorMsg = "Erreur lors de la récupération des données";
              showErrorMessage();
            }
          })
          .catch((e) => {
            this.errorMsg = e;
            showErrorMessage();
          });
      }
    },

    // Récupérer la liste des utilisateurs crees par compagnie de transport
    async toGetAllUsersCreated() {
      if (
        this.$store.state.userAuthentified.roleCode !== "RoleAdminSocieteMere"
      ) {
        this.loading = true;
        this.simpleObjectToSend.data.compagnieTransportRaisonSociale =
          this.$store.state.userAuthentified.compagnieTransportRaisonSociale;
        await axios
          .post(API_GET_USERS_BY_COMPAGNIE_TRANSPORT, this.simpleObjectToSend, {
            headers: HEADERS(this.$store.state.userAuthentified.token),
          })
          .then((response) => {
            if (response.status == 200) {
              if (response.data.status.code != 800) {
                this.errorMsg = response.data.status.message;
                showErrorMessage();
              } else {
                this.usersList = response.data.items;
              }
            } else {
              this.errorMsg = "Erreur";
              showErrorMessage();
            }
          })
          .catch((e) => {
            this.errorMsg = e;
            showErrorMessage();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },

  computed: {
    headers() {
      return [
        { text: this.$t('manageUsers.nom'), value: 'nom', align: 'start' },
        { text: this.$t('manageUsers.login'), value: 'login', align: 'start' },
        { text: 'Rôle', value: 'roleCode', align: 'start' },
        { text: 'Statut', value: 'isActif', align: 'start' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'end', width: '90px' },
        // Colonnes masquées : gardées pour que la recherche porte aussi sur ces champs
        { text: '', value: 'prenoms', align: ' d-none' },
        { text: '', value: 'email', align: ' d-none' },
      ];
    },

    roleLabels() {
      return {
        'RoleAdminCompagnieTransport': 'Administrateur de compagnie',
        'RoleUtiGareCompagnieTransport': 'Vendeur',
        'RoleAgentGare': 'Responsable de gare',
        'RoleUtiBagagiste': 'Bagagiste',
      };
    },

    isAdminSocieteMere() {
      return this.$store.state.userAuthentified.roleCode == "RoleAdminSocieteMere";
    },
  },

  mounted() {
    this.toGetAllUsersCreated();
    this.getCompagnieTransportList();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/admin/ui";

.su-user {
  padding: 6px 0;
}

.su-user__name {
  font-weight: 700;
  color: $ov-navy;
}

.su-user__email {
  font-size: 12px;
  color: $ov-muted;
}

.su-actions {
  justify-content: flex-end;
}
</style>
